import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import { StyledReview } from "./review.scss";
class Review extends PureComponent {
    renderReviewContent() {
        const { reviewContent } = this.props;
        return reviewContent.map((line, index)=>/*#__PURE__*/ _jsx("div", {
                className: "line",
                dangerouslySetInnerHTML: {
                    __html: line
                }
            }, index));
    }
    render() {
        const { reviewerName, reviewedOn } = this.props;
        return /*#__PURE__*/ _jsxs(StyledReview, {
            className: "review-component",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "review-content",
                    children: this.renderReviewContent()
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "reviewer-name",
                    children: reviewerName
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "reviewed-on",
                    children: [
                        "Reviewed on ",
                        reviewedOn
                    ]
                })
            ]
        });
    }
    constructor(props){
        super(props);
    }
}
export { Review as default };
Review.defaultProps = {
    reviewContent: []
};
